import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import ContractTable from './components/ContractTable';

interface Props {
  isShowComponents: boolean;
  isCanUpdate?: boolean;
  employeeData: any;
  setEmployeeData?: any;
  status?: any;
  callBack: any;
  monthYear: any;
  payrollUpdate: any;
  reloadContract: any;
  isPayRun: any;
}

const ContractInformantionFields = (props: Props) => {
  const {
    isShowComponents,
    employeeData,
    callBack,
    monthYear,
    payrollUpdate,
    reloadContract,
    isPayRun,
  } = props;
  const { t } = useTranslation(['employee']);

  return (
    <div style={isShowComponents ? {} : { display: 'none' }}>
      <SkillInfoTitle>
        {t('employee:contract_information_fields.contract_information')}
      </SkillInfoTitle>
      <div style={{ backgroundColor: '#fff' }}>
        <ContractTable
          employeeData={employeeData}
          callBack={callBack}
          monthYear={monthYear}
          payrollUpdate={payrollUpdate}
          reloadContract={reloadContract}
          isPayRun={isPayRun}
        />
      </div>
    </div>
  );
};

export default ContractInformantionFields;
export const SkillInfoTitle = styled.div`
  height: 38px;
  font-size: 20px;
  font-weight: 550;
  background-color: var(--cl_gray200);
  border-radius: 5px;
  line-height: 38px;
  padding: 25px 10px 25px 10px;
  bottom: 1000px;
  margin-top: 25px;
  margin-bottom: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
